import * as Request from '../Request';

const Video = {
  list: (data) => {
    return Request.post('/edu/video/list', data);
  },
  edit: (data) => {
    return Request.post('/edu/video/update', data);
  },
  del: (data) => {
    return Request.del('/edu/video/delete', data);
  },
  add: (data) => {
    return Request.post('/edu/video/save', data);
  },
  upload: (data) => {
    return Request.post('/edu/video/upload', data);
  },
  // 播放
  play: (data) => {
    return Request.get('/edu/video/play', data);
  }

}
export default Video
